import { Injectable } from '@angular/core';
import { SandboxUtilsService } from './sandbox-utils.service';
import { environment } from '../../../../environments/environment';
import { HeadersRequestEnum } from '../../enums/headers-request.enum';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';
import { IAxiosResponse } from '../../models/IAxiosResponse';
import { IResponseFromFetch } from '../../models/IResponseFromFetch';
import { IPropertiesDecrypt, NaclSbxUtil } from '@npm-bbta/bbog-ate-sbx-utilities-lib';
import axios from 'axios';
import { CustomLogger } from '@npm-bbta/bbog-sg-frontend-logs-lib';

const logger = new CustomLogger('SandboxRequestService', '#A2522B');

@Injectable()
export class SandboxRequestService {

  constructor(
    private readonly sandboxUtilsService: SandboxUtilsService,
    private readonly sessionStorageService: BdbSessionStrgService
  ) {}

  /**
   * @deprecated Favor usar `SandboxService` en su lugar
   */
  async requestPostSandbox(urlRequest: string, bodyRequest: any, initialHeaders?: any, plainText = false, bff = false) {
    logger.group('[requestPostSandbox v3] %s', urlRequest);
    const uuid = this.getUuidAuth();
    bodyRequest = plainText ? JSON.stringify(bodyRequest) : bodyRequest;
    const encryptedBody = await this.sandboxUtilsService.encipherData(bodyRequest, uuid);
    const customHeaders: any = await this.sandboxUtilsService.updateHeaders(initialHeaders, encryptedBody, uuid);
    if (bff) {
      delete customHeaders[HeadersRequestEnum.X_UUIDAUTH];
    }
    try {
      const response = await axios.post(urlRequest, encryptedBody, {
        headers: customHeaders,
        timeout: environment.timeSanboxMethod,
        validateStatus: () => true
      })

      return this.handlerSuccessResponse(response as any);
    } catch (e) {
      return this.handlerErrorResponse(e);
    } finally {
      logger.groupEnd();
    }
  }

  /**
   * @deprecated Favor usar `SandboxService` en su lugar
   */
  async requestGetSandbox(urlRequest: string, headersRequest?: any, queryParams?: any): Promise<IResponseFromFetch> {
    logger.group('[requestGetSandbox v3] %s', urlRequest);
    const uuid = this.getUuidAuth();
    const cipherQueryParams = queryParams ? await this.sandboxUtilsService.encipherData(queryParams, uuid) : undefined;
    const customHeaders: any = await this.sandboxUtilsService.updateHeaders(headersRequest, cipherQueryParams, uuid);

    if (cipherQueryParams) {
        urlRequest += `?cypher=${cipherQueryParams}`
    }

    try {
      const response = await axios.get(urlRequest, {
        headers: customHeaders,
        timeout: environment.timeSanboxMethod,
      })

      return this.handlerSuccessResponse(response as any);
    } catch (e) {
      return this.handlerErrorResponse(e);
    } finally {
      logger.groupEnd();
    }
  }

  async requestGetSandboxWithoutQueryParams(urlRequest: string, headersRequest?: any): Promise<IResponseFromFetch> {
    logger.group('[requestGetSandbox v2] %s', urlRequest);
    const uuid = this.getUuidAuth();
    const customHeaders: any = await this.sandboxUtilsService.updateHeaders(headersRequest, '', uuid);
    try {
      const response = await axios.get(urlRequest, {
        headers: customHeaders,
        timeout: environment.timeSanboxMethod,
      })

      return this.handlerSuccessResponse(response as any);
    } catch (e) {
      return this.handlerErrorResponse(e);
    } finally {
      logger.groupEnd();
    }
  }

  async handlerSuccessResponse(responseSbdx: IAxiosResponse) {
    logger.log('[handlerSuccessResponse] Response', responseSbdx);

    const authToken = responseSbdx.headers[HeadersRequestEnum.X_AUTH_TOKEN];
    const body = responseSbdx.data;
    const bodyDecrypt = this.decipherData(body, authToken);
    logger.log('[handlerSuccessResponse] Body-Decrypt ', bodyDecrypt);

    return {
      body: bodyDecrypt,
      status: responseSbdx.status
    }
  }

  async handlerErrorResponse(error: any) {
    logger.error('[handlerErrorResponse] Error ', error);
    const headersResponse = this.sandboxUtilsService.getHeadersResponse(error);
    logger.error('[handlerErrorResponse] Headers response Error', headersResponse);
    const authToken = headersResponse[HeadersRequestEnum.XAUTHTOKEN] || undefined;

    if (authToken) {
      const body = error.error;
      const bodyDecrypt = await this.sandboxUtilsService.decipherData(
        body,
        authToken
      );

      logger.error('[handlerErrorResponse] Error-Body-Decrypt', bodyDecrypt);

      return {
        body: bodyDecrypt,
        status: error.status
      };
    }

    return Promise.reject(error);
  }

  decipherData(data: string, authToken: string) {
    const sk = environment.sandbox.sk;
    const sandboxParameters = this.getParametersDecryptForSandbox(authToken);
    try {
      return NaclSbxUtil.validateJWT(data, sk, sandboxParameters);
    } catch (e) {
      logger.error('[ERROR] Error in decipherData', e);
      throw e;
    }
  }

  getParametersDecryptForSandbox(authToken): IPropertiesDecrypt {
    const parameters: any = environment.propertiesSandbox;
    parameters.Seed = {
      nonce: NaclSbxUtil.generateCustomNonce(authToken),
    };
    return parameters;
  }

  private getUuidAuth(): string {
    return this.sessionStorageService.get(SessionStorageKeysEnum.UUID_AUTH) ||
      this.sessionStorageService.get(SessionStorageKeysEnum.SPECIFIC_PRODUCT_INFO_UUID);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sandbox/sandbox-request.service.ts